export default {
    slug: 'quickbooks',
    ability: 'quickbooks',
    routes: [],
    integrationRoutes: [
        {
            path: 'quickbooks',
            name: 'settings-quickbooks',
            component: () => import('@modules/SyncQuickBooks/Resources/js/pages/QuickBooksSettings.vue'),
            meta: { label: 'QuickBooks' }
        }
    ],
    integrationTabs: () => [
        {
            title: i18n.t('QuickBooks'),
            icon: 'book-sync',
            route: 'settings-quickbooks',
            position: 10
        }
    ]
};
